import { Order } from '../types/order';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/order/list';

export namespace OrderRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<Order>> => {
    return (await http.post(LIST, payload)).data;
  };
}
